// extracted by mini-css-extract-plugin
export default {"button":"Button_button__wiIYs","horizontal":"Button_horizontal__WF8jl","vertical":"Button_vertical__jibIM"};